jQuery(document).ready(function() {

 //in view header show fixed header 
jQuery('header#masthead #nav-wrap').bind('inview', function (event, visible) {
  if (visible == true) {
    // element is now visible in the viewport
	if(jQuery(window).width() > 1250) {
	jQuery('header#fixed-header').hide();
	}
  } else {
    // element has gone out of viewport
	jQuery('header#fixed-header').slideDown('fast');
  }
});



// resize page padding
if(jQuery(window).width() < 1250) {
jQuery('#page').css('margin-top',jQuery('header#fixed-header').outerHeight());
}
jQuery(window).on('resize', function(){
if(jQuery(window).width() < 1250) {	
jQuery('header#fixed-header').slideDown('fast');
jQuery('#page').css('margin-top',jQuery('header#fixed-header').outerHeight());
}else{
jQuery('#page').css('margin-top','0px');
jQuery('header#fixed-header').hide();
}
});
  
  
  headercheck();
function headercheck() {
var headeroutofview = jQuery( 'header#masthead #nav-wrap').is(':off-top');
if(headeroutofview == true) {
 jQuery('header#fixed-header').slideDown('fasr');
};
}
  

});
